import { memo, useCallback } from "react";

import { CollectionAdjacentCollectionButtonView } from "@react/sections/Collection/CollectionFilterNavigation/CollectionAdjacentCollectionButton.view";

type Props = {
  adjacentCollection: {
    handle: string;
    id: string;
    onlineStoreUrl: string | null | undefined;
    title: string;
  };
  handleAdjacentCollectionChange: (collection: {
    handle: string;
    id: string;
    onlineStoreUrl: string | null | undefined;
    title: string;
  }) => void;
  isActive: boolean;
};

const CollectionAdjacentCollectionButtonBase = ({
  adjacentCollection,
  handleAdjacentCollectionChange,
  isActive,
}: Props) => {
  const handleAdjacentCollectionButtonClick = useCallback(() => {
    handleAdjacentCollectionChange(adjacentCollection);
  }, [adjacentCollection, handleAdjacentCollectionChange]);

  return (
    <CollectionAdjacentCollectionButtonView
      adjacentCollection={adjacentCollection}
      handleAdjacentCollectionButtonClick={handleAdjacentCollectionButtonClick}
      isActive={isActive}
    />
  );
};

export const CollectionAdjacentCollectionButton = memo(
  CollectionAdjacentCollectionButtonBase
);
